import { useContext } from "react";
import Button from "../../Button";
import styles from "./index.module.css";
import ServiceIcon from "../../Icon/ServiceIcon";
import { useTranslation } from "react-i18next";
import { Link } from "@mui/joy";
import Contexts from "../../../contexts/Contexts";

const Footer = () => {
  const { t } = useTranslation();
  const { user, userId } = useContext(Contexts);
  // /operacao is master-only: visible to logged-in approved house masters
  // (is_affiliate_master), hidden from guests, regular customers, and approved
  // sub-affiliate employees. "Para parceiros" below stays ungated for everyone.
  const loggedIn = !!(userId && userId !== 0 && !user?.isGuest);
  const showOperacao = loggedIn && user?.is_affiliate_master === true;
  return (
    <div className={styles.footerContainer}>
      <div className={styles.footer}>
        <div>
          <div className={styles.logo}>
            <picture>
              <source srcSet="/images/logo.webp" type="image/webp" />
              <img src="/images/logo.png" width="89" height="43" alt="" loading="lazy" decoding="async" />
            </picture>
          </div>
        </div>
        <div>
          <div className={styles.title}>{t("footer.navigation")}</div>
          <div className={styles.navLinks}>
            <Link href="/games">Jogos</Link>
            <Link href="/groups">Bolão</Link>
            <Link href="/my-tickets">Apostas</Link>
            <Link href="/parceiros">Para parceiros</Link>
            {showOperacao && <Link href="/operacao">Painel do parceiro</Link>}
          </div>
        </div>
        <div>
          <div className={styles.title}>{t("footer.legal")}</div>
          <div className={styles.navLinks}>
            <Link href="/about">{t("footer.about")}</Link>
            <Link href="/contacts">{t("footer.contacts")}</Link>
            <Link href="/privacidade">{t("footer.privacy")}</Link>
            <Link href="/termos">{t("termsOfService.title")}</Link>
            <Link href="/jogo-responsavel">Jogo Responsável</Link>
          </div>
        </div>
        <div>
          <div className={styles.title}>{t("footer.support")}</div>
          <div className={styles.supportText}>{t("footer.supportText")}</div>
          <div>
            <a href="mailto:ajuda@levesorte.com" style={{ textDecoration: "none" }}>
              <Button width="240px">
                <ServiceIcon size="16px" />
                {t("footer.contactSupport")}
              </Button>
            </a>
          </div>
        </div>
      </div>

      {/* Trust strip */}
      <div className={styles.trustStrip}>
        <div className={styles.trustLeft}>
          <div className={styles.badge18}>+18</div>
          <a href="/jogo-responsavel" className={styles.responsibleLink}>
            <span className={styles.responsibleTitle}>Jogo Responsável</span>
            <span className={styles.responsibleSub}>Apostas para maiores de 18 anos</span>
          </a>
          <div className={styles.pixBadge}>
            <picture>
              <source srcSet="/images/pix.webp" type="image/webp" />
              <img src="/images/pix.png" alt="Pix" className={styles.pixLogo} width={102} height={37} loading="lazy" decoding="async" />
            </picture>
            <span className={styles.pixText}>Pagamento seguro</span>
          </div>
        </div>
        <div className={styles.trustRight}>
          © 2026 Leve Sorte Brasil LTDA · CNPJ 61.709.901/0001-41
        </div>
      </div>

      <div className={styles.footerBottom}>
        <div>
          Ao pagar com Pix, você concorda com os{" "}
          <a href="/termos" style={{ color: "inherit", textDecoration: "underline" }}>
            {t("termsOfService.title")}
          </a>{" "}
          e a{" "}
          <a href="/privacidade" style={{ color: "inherit", textDecoration: "underline" }}>
            {t("privacyPolicy.title")}
          </a>
        </div>
        <div>
          A Leve Sorte não possui qualquer vínculo com a Caixa Econômica Federal.
          Trata-se de uma empresa independente que atua exclusivamente como intermediadora.
          Todos os produtos lotéricos ofertados na plataforma são adquiridos e processados
          por meio dos canais oficiais da Caixa Econômica Federal.
        </div>
      </div>
    </div>
  );
};

export default Footer;
